import { createBrowserRouter } from 'react-router';
import HomePage from './pages/';
import MainLayout from './layouts/MainLayout';
import { engineRoutes } from './pages/engine/routes';
import { agencyRoutes } from './pages/agency/routes';
import { teamRoutes } from './pages/team/routes';
import { clientRoutes } from './pages/client/routes';
import { authMiddleware } from './middleware/auth';

import Login from './pages/login';
import Lobby from './pages/lobby';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: '*', element: <div>404 Not Found</div> },
    ],
  },
  { path: 'login', element: <Login /> },
  { path: 'lobby', element: <Lobby /> },
  { ...engineRoutes, middleware: [authMiddleware(['owner'])] },
  { ...agencyRoutes, middleware: [authMiddleware(['owner'])] },
  { ...teamRoutes, middleware: [authMiddleware(['team'])] },
  { ...clientRoutes, middleware: [authMiddleware(['client'])] },
]);

export default router;
